import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
    MatButtonModule, MatChipsModule, MatExpansionModule, MatFormFieldModule, MatIconModule, MatInputModule, MatPaginatorModule, MatRippleModule, MatSelectModule, MatSnackBarModule,
    MatSortModule,
    MatTableModule, MatTabsModule
} from '@angular/material';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { AgmCoreModule, GoogleMapsAPIWrapper } from '@agm/core';

import { FuseSharedModule } from '@fuse/shared.module';
import { FuseWidgetModule } from '@fuse/components/widget/widget.module';

import { Home2Component } from 'app/main/landingpage/home-2/home-2.component';
import { HomeService } from 'app/main/service/home.service';
import { ResultComponent } from 'app/main/landingpage/result/result.component';
import { Home2SearchComponent } from 'app/main/landingpage/home-2/search/home-search.component';
import { HomeMapContentComponent } from 'app/main/landingpage/home-2/home-map-content.component';
import { ContainerModalFormDialogComponent } from 'app/main/landingpage/home-2/container-modal/container-modal-form.component';

import { ResultMapContentComponent } from 'app/main/landingpage/result/result-map-content.component';
import { HomeResultComponent } from 'app/main/landingpage/result/result/home-result.component';
import { FclInfoComponent } from 'app/main/landingpage/fcl-info/fcl-info.component';
import { FclPriceListComponent } from 'app/main/landingpage/fcl-info/fcl-price-list/fcl-price-list.component';
import { FclInfoService } from 'app/main/service/fcl-info.service';
import { SearchHistoryComponent } from 'app/main/landingpage/search-history/search-history.component';
import { UserSearchService } from 'app/main/service/user-search.service';

import { MatDialogModule, MatSlideToggleModule, MatToolbarModule, MatTooltipModule, MatAutocompleteModule, MatMenuModule } from '@angular/material';

import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatRadioModule } from '@angular/material/radio';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { FclPriceComponent } from 'app/main/landingpage/fcl-price/fcl-price.component';
import { UnitFilterPipe } from 'app/main/landingpage/fcl-price/fcl-price.pipe';
import { AuthGuard } from 'app/auth.guard';

const routes: Routes = [
    /*{
        path        : 'home',
        loadChildren: './home/home.module#HomeModule'
    },*/
    {
        path     : 'home2',
        component: Home2Component,
        resolve  : {
            data : HomeService
        }
    },
    {
        path     : 'fcl-price/:id',
        component: FclPriceComponent,
        resolve  : {
            data : FclInfoService
        }
    },
    {
        path     : 'result',
        canActivate: [AuthGuard],
        component: ResultComponent,
    },
    {
        path     : 'result/:pol/:pod/:etd',
        canActivate: [AuthGuard],
        component: ResultComponent,
    },
    {
        path     : 'fcl-info/:id',
        canActivate: [AuthGuard],
        component: FclInfoComponent,
        resolve  : {
            data : FclInfoService
        },
    },
    {
        path     : 'user-search',
        canActivate: [AuthGuard],
        component: SearchHistoryComponent,
        resolve  : {
            data : UserSearchService
        },
    },
];

@NgModule({
    declarations: [
        Home2Component,
        ResultComponent ,
        Home2SearchComponent,
        HomeMapContentComponent,
        ContainerModalFormDialogComponent,
        ResultMapContentComponent,
        HomeResultComponent,
        FclInfoComponent,
        FclPriceListComponent,
        SearchHistoryComponent,
        FclPriceComponent,
        UnitFilterPipe
    ],
    imports     : [
        RouterModule.forChild(routes),

        MatButtonModule,
        MatChipsModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatPaginatorModule,
        MatRippleModule,
        MatSelectModule,
        MatSortModule,
        MatSnackBarModule,
        MatTableModule,
        MatTabsModule,

        NgxChartsModule,

        FuseSharedModule,
        FuseWidgetModule,

        AgmCoreModule.forRoot({
            apiKey: 'AIzaSyCfm3qKKkmdahsi2GXjO2PE7whvtYXjmjA',
            language: 'en'
        }),

        MatDialogModule, 
        MatSlideToggleModule, 
        MatToolbarModule, 
        MatTooltipModule, 
        MatAutocompleteModule, 
        MatMenuModule,
        MatDatepickerModule,
        MatRadioModule,
        MatButtonToggleModule,
    ],
    providers   : [
        GoogleMapsAPIWrapper
    ],
    entryComponents: [
        ContainerModalFormDialogComponent
    ]
})

export class LandingpageModule
{

}
